(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chef-intro-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.chefs-intro__carousel');

    carousels.forEach(function(carousel) {
      const splide = new Splide(carousel);

      const STATE_CLASSES = ['slide-enter', 'slide-exit', 'slide-left'];

      function forEachElementOfSlide(Slide, cb) {

// Slide.slide is the original; Slide.clones is an array of clones
        const elements = [Slide.slide].concat(Slide.clones || []);
        elements.forEach(cb);
      }

      function updateSlideStates(newIndex, prevIndex) {
        const Slides = splide.Components.Slides.get(); // logical slides

        Slides.forEach(function(Slide) {
          const logicalIndex = Slide.index;

// index in the original set

// Clear all our state classes on original + clones
          forEachElementOfSlide(Slide, function(el) {
            el.classList.remove(... STATE_CLASSES);
          });

// 1) Newly active slide
          if (logicalIndex === newIndex) {
            forEachElementOfSlide(Slide, function(el) {
              el.classList.add('slide-enter');

              el.addEventListener('animationend', function handler() {
                el.classList.remove('slide-enter');
                el.removeEventListener('animationend', handler);
              }, {once: true});
            });
          }

// 2) Slide that just stopped being active
          if (prevIndex != null && prevIndex !== newIndex && logicalIndex === prevIndex) {
            forEachElementOfSlide(Slide, function(el) {
              el.classList.add('slide-exit');

              el.addEventListener('animationend', function handler() {
                el.classList.remove('slide-exit');
                el.removeEventListener('animationend', handler);
              }, {once: true});
            });
          }

// 3) Slides to the left of the active slide
          if (logicalIndex < newIndex) {
            forEachElementOfSlide(Slide, function(el) {
              el.classList.add('slide-left');
            });
          }
        });
      }

// Initial state
      splide.on('mounted', function() {
        updateSlideStates(splide.index, null);
      });

// Fires right when movement starts
      splide.on('move', function(newIndex, prevIndex) {
        updateSlideStates(newIndex, prevIndex);
      });

      splide.mount();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creator-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var splideElements = document.querySelectorAll('.creator-carousel .splide');
    splideElements.forEach(function(splideElement) {
      var splide = new Splide(splideElement, {
        type: 'fade',
        rewind: true,
        arrows: false,
        pagination: false,
        autoplay: false,
        speed: 600
      });
      splide.mount();

// Wire up custom arrow buttons
      var prevButtons = splideElement.querySelectorAll('.creator-arrow--prev');
      var nextButtons = splideElement.querySelectorAll('.creator-arrow--next');

      prevButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          splide.go('<');
        });
      });

      nextButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          splide.go('>');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqToggles = document.querySelectorAll('[data-faq-toggle]');

    faqToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const answer = toggle.parentElement.querySelector('[data-faq-answer]');

        if (isExpanded) {
          toggle.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = '0';
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-highlight"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel(carousel) {
      if (carousel.splide) {
        carousel.splide.destroy(true);
      }

      const autoplay = carousel.dataset.autoplay === 'true';
      const interval = parseInt(carousel.dataset.interval) || 5000;
      const pauseOnHover = carousel.dataset.pauseOnHover === 'true';

      carousel.splide = new Splide(carousel, {
        type: 'loop',
        autoplay: true,
        interval: interval,
        pauseOnHover: pauseOnHover,
        pauseOnFocus: true,
        speed: 800,
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
        pagination: true,
        arrows: false,
        drag: true,
        keyboard: true,
        rewind: true,
        rewindByDrag: true,
        accessibility: {
          container: true,
          slideContainer: true,
          list: true,
          slide: true
        },
        classes: {
          pagination: 'splide__pagination feature-highlight__pagination'
        }
      }).mount();
    }

    function initCarousels(root) {
      const carousels = root.querySelectorAll('.feature-highlight__carousel');
      if (!carousels.length) return;

      // The Splide CDN script may not have executed yet when the editor
      // injects a section, so poll briefly before giving up.
      let attempts = 0;
      (function tryInit() {
        if (typeof Splide === 'undefined') {
          if (attempts++ < 50) setTimeout(tryInit, 100);
          return;
        }
        carousels.forEach(initCarousel);
      })();
    }

    document.addEventListener('DOMContentLoaded', function() {
      initCarousels(document);
    });

    document.addEventListener('shopify:section:load', function(event) {
      initCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-the-app"] && !Shopify.designMode) return;
  try {
    
  /**
   * Swaps the fallback rating for the live App Store rating. Hides the line
   * when the app has fewer ratings than data-min-count, and keeps the
   * fallback if the lookup fails.
   */
  class AppStoreRating extends HTMLElement {
    connectedCallback() {
      const { appId, country, minCount } = this.dataset;
      if (!appId) return;

      const params = new URLSearchParams({ id: appId });
      if (country) params.set('country', country);

      fetch(`https://itunes.apple.com/lookup?${params}`, { signal: AbortSignal.timeout?.(4000) })
        .then((response) => (response.ok ? response.json() : Promise.reject(response)))
        .then((data) => {
          const app = data.results && data.results[0];
          if (!app || typeof app.averageUserRating !== 'number') return;

          if ((app.userRatingCount || 0) < Number(minCount || 0)) {
            this.hidden = true;
            return;
          }

          const value = this.querySelector('[data-rating-value]');
          if (value) value.textContent = app.averageUserRating.toFixed(1);
        })
        .catch(() => {})
        .finally(() => this.removeAttribute('data-pending'));
    }
  }

  if (!customElements.get('app-store-rating')) {
    customElements.define('app-store-rating', AppStoreRating);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-text-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const rotatingContainers = document.querySelectorAll('.rotating-text-hero__rotating-text');

    rotatingContainers.forEach(function(container) {
      const phrases = container.querySelectorAll('.rotating-text-hero__phrase');
      const animationSpeed = parseInt(container.dataset.animationSpeed) || 3000;

      if (phrases.length === 0) return;
      


      let currentIndex = 0;

// Show first phrase
      phrases[currentIndex].classList.add('is-active');

      function rotatePhrases() {
        const currentPhrase = phrases[currentIndex];
        const nextIndex = (currentIndex + 1) % phrases.length;
        const nextPhrase = phrases[nextIndex];

// Exit current phrase
        currentPhrase.classList.add('is-exiting');
        currentPhrase.classList.remove('is-active');

// After transition, enter next phrase
        setTimeout(function() {

// Disable transition for instant reset
          currentPhrase.style.transition = 'none';
          currentPhrase.classList.remove('is-exiting');

// Force reflow
          currentPhrase.offsetHeight;

// Re-enable transition
          currentPhrase.style.transition = '';

          nextPhrase.classList.add('is-active');
          currentIndex = nextIndex;
        }, 600); // Match CSS transition duration
      }

// Start rotation
      setInterval(rotatePhrases, animationSpeed);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-pill-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const textElements = document.querySelectorAll('.video-pill-showcase__text');

    if (textElements.length === 0) return;
    


// Create intersection observers with different thresholds
    const observerOptionsLeft = {
      root: null,
      rootMargin: '-70% 0px -20% 0px', // Triggers just before center
      threshold: 0
    };

    const observerOptionsRight = {
      root: null,
      rootMargin: '-40% 0px -50% 0px', // Triggers slightly after left text
      threshold: 0
    };

    const animateOnScroll = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target); // Stop observing after animation
        }
      });
    };

    const observerLeft = new IntersectionObserver(animateOnScroll, observerOptionsLeft);
    const observerRight = new IntersectionObserver(animateOnScroll, observerOptionsRight);

    textElements.forEach(textElement => {
      const animateDirection = textElement.getAttribute('data-animate');

      if (animateDirection === 'left') {
        observerLeft.observe(textElement);
      } else if (animateDirection === 'right') {
        observerRight.observe(textElement);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoom-scroll-animation"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initZoomScrollAnimation() {
      const sections = document.querySelectorAll('.zoom-scroll-animation');

      sections.forEach(function(section) {
        const mediaWrapper = section.querySelector('[data-zoom-target]');
        if (! mediaWrapper) return;
        


        const initialScale = parseFloat(section.dataset.initialScale) || 0.5;
        let ticking = false;

        function updateScale() {
          const rect = section.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

// Calculate progress: 0 when section enters, 1 when section bottom = viewport bottom
// Section bottom position relative to viewport bottom
          const sectionBottom = rect.bottom;
          const sectionHeight = rect.height;
          const sectionTop = rect.top;

// Progress calculation:
// Start: when section top enters viewport (top = viewportHeight)
// End: when section bottom aligns with viewport bottom (bottom = viewportHeight)
          const scrollStart = viewportHeight - sectionTop;
          const scrollRange = sectionHeight;
          const progress = Math.max(0, Math.min(1, scrollStart / scrollRange));

// Interpolate scale from initialScale to 1.0
          const scale = initialScale + (1 - initialScale) * progress;

          mediaWrapper.style.transform = `scale(${scale})`;
          ticking = false;
        }

        function onScroll() {
          if (! ticking) {
            window.requestAnimationFrame(updateScale);
            ticking = true;
          }
        }

// Initialize
        updateScale();

// Listen to scroll events
        window.addEventListener('scroll', onScroll, {passive: true});
        window.addEventListener('resize', updateScale, {passive: true});
      });
    }

// Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initZoomScrollAnimation);
    } else {
      initZoomScrollAnimation();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
